import type { z } from "zod";

import { formatCurrency } from "../../../@lib-i18n";
import type { PurchaseResponseSchema } from "../terminal-purchase/schemas";
import type { RefundResponseSchema } from "../terminal-refund/shared/schemas";
import { getCodeState } from "./get-declined-page-props/get-code-state";

export namespace getPageProps {
	export type Options = {
		data: z.infer<typeof PurchaseResponseSchema>["data"] &
			z.infer<typeof RefundResponseSchema>["data"];
	};
}

export function getPageProps(options: getPageProps.Options): {
	title: string;
	subtitle: string | undefined;
	message: string | undefined;
} {
	const { data } = options;

	const defaultTitle = `${formatCurrency({
		amountInCents: data.amount,
		currency: data.currency,
	})} Declined`;
	const codeState = getCodeState({ code: data.responseCode });
	return {
		title: codeState?.title ?? defaultTitle,
		subtitle: codeState.subtitle,
		message: codeState.message,
	} as const;
}
